import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './styles/main.scss';
//include non React Js files here 
import navigation from './modules/navigation/navigation';
import './App';
import svgxhr from '../node_modules/webpack-svgstore-plugin/src/helpers/svgxhr';
import { scrollIntoView, insertUrlParam, getUrlParamValue } from './utilities/browser';

// Sub jump link
window.onload = function () {
  var subJumpLinkBtn = document.querySelector('#subJumpLink');
  var query = getUrlParamValue('jumpto');
  var jumpToSub = function jumpToSub() {
    var signUpComponent = document.querySelector('#subscribe');
    if (signUpComponent) {
      scrollIntoView(signUpComponent, 'smooth');
    }
  };
  if (query === 'subscribe') {
    setTimeout(function () {
      jumpToSub();
    }, 500);
  }
  subJumpLinkBtn.addEventListener('click', function (event) {
    event.preventDefault();
    insertUrlParam('jumpto', 'subscribe');
    jumpToSub();
  });
};

/**
 * You can create multiple svg stores using the same method shown below
 * Example: const __sprite__ = { ... };
 * svgxhr(__sprite__);
 */
var __svg__ = {
  path: './media/img/svg/*.svg',
  name: 'sprite-store.svg'
};
svgxhr(__svg__);

/**
 * Initalise navigation
 */
navigation('#toggleNav');

/**
 * Dev 
 */
// import './dev/grid';